/* global mixpanel */
import { put, call, select } from 'redux-saga/effects'
import * as actions from '../action_creators'
import * as client from '../../api/client'
import * as dateUtils from '../../util/date_utils'
import { getProfileId, getGoals, getCurrentRange } from '../selectors'
import { makeToast } from "../../util/toast_util"
import moment from "moment-timezone"
import GA from "react-ga"
const timezone = moment.tz.guess()

export function* fetchGoalForCurrentRange(goalID) {
    const range = yield select(getCurrentRange)
    const rangeMidpoint = Math.round(range.start + ( ( range.end - range.start )/2 ))
    yield call( handleFetchGoals, {goalID, today: rangeMidpoint} )
}

export function* fetchGoalsForRange({range}) {
    const rangeMidpoint = range.start + ( ( range.end - range.start )/2 )
    yield put(actions.fetchGoals({
        today: Math.round(rangeMidpoint),
    } ))
}

export function* handleCreateGoal({ goal }) {
    const { interval } = goal
    const newSpan = dateUtils.getDefaultTimespanBackward(interval.charAt(0).toUpperCase() + interval.slice(1))
    goal.startDate = newSpan.start / 1000
    try {
        const resp = yield call(client.postGoal, goal)
        if (resp === undefined) return

        const goalId = resp.id
        yield call(fetchGoalForCurrentRange, goalId)

        const { tags, teamId, budgetDuration } = goal
        mixpanel.track("Goal created", { goalId, tags, teamId, interval, budgetDuration })
        GA.event({category: "User", action: "Goal created"})

        console.log(`Goal ${goal} created.`) // eslint-disable-line no-console
    } catch (e) {
        const errorMsg = "Failed to create goal"
        console.log(errorMsg + ", error: ", e) // eslint-disable-line no-console
        yield call(makeToast, errorMsg, "danger")
    }
}

export function* handleDeleteGoal({ goal }) {
    try {
        const resp = yield call(client.deleteGoal, goal)
        if (resp === undefined) return
        yield put(actions.removeGoal(goal))
    } catch (e) {
        const errorMsg = "Failed to delete goal"
        console.log(errorMsg + ", error: ", e) // eslint-disable-line no-console
        yield call(makeToast, errorMsg, "danger")
    }
}

export function* handleUpdateGoal({ goal }) {
    goal.startDate = Math.round(goal.startDate / 1000)
    goal.endDate = goal.endDate ? Math.round(goal.endDate / 1000) : undefined
    goal.createdAt = Math.round(goal.createdAt / 1000)
    goal.updatedAt = Math.round(goal.updatedAt / 1000)
    goal.progress = undefined
    goal.timezone = timezone

    try {
        const resp = yield call(client.putGoal, goal)
        if (resp === undefined) return

        yield call(fetchGoalForCurrentRange, goal.id)

        console.log(`Goal ${goal} updated.`) // eslint-disable-line no-console
    } catch (e) {
        const errorMsg = "Failed to update goal"
        console.log(errorMsg + ", error: ", e) // eslint-disable-line no-console
        yield call(makeToast, errorMsg, "danger")
    }
}

export function* handleFetchGoals({ params }) {
    // for now... only fetch goals owned by you
    const ownerId = yield select(getProfileId)
    const paramsToUse = {
        ...params,
        ownerId,
        timezone,
    }
    try {
        const resp = yield call( client.getGoals, null, paramsToUse )
        if (resp === undefined) return
        yield put( actions.receiveGoals(resp) )
    } catch (e) {
        console.log('Failed to fetch goals, error: ', e) // eslint-disable-line no-console
        // yield call(makeToast, "Failed to fetch goals", "danger")
    }
}

export function* refreshGoalsFromTimeEntry({timeEntry}) {
    const goals = yield select(getGoals)
    if (!goals) {
        return
    }

    const goalsArray = Object.keys(goals).reduce((acc, k) => [...acc, goals[k]], []) || []
    const timeEntryTags = timeEntry.tags
    const goalsToRefresh = goalsArray.filter( goal =>
        timeEntryTags.filter( t => goal.tags.reduce( (acc, t) => ({[t.tagId]: t.tagId}), {})[t]).length > 0
    )

    // good ole' for loop since for some reason forEach and map
    // don't play nicely with yield
    for ( let i = 0; i < goalsToRefresh.length; i++ ) {
        const goal = goalsToRefresh[i]
        yield call(fetchGoalForCurrentRange, goal.id)
    }

}


// WEBPACK FOOTER //
// ./src/redux/sagas/goal_sagas.js